<template>
    <v-sheet max-width="1920" color="#49832E" class="score-board py-16px py-lg-22px mx-auto">
        <v-container>
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <template v-for="item in logs">
                        <div class="swiper-slide" :key="item">{{ item.config.ranking }}등 {{ item.user.name }} ({{ item.user.phone }})</div>
                    </template>
                </div>
            </div>
        </v-container>
    </v-sheet>
</template>

<script>
export default {
    props: {
        logs: { type: Array, default: [] }
    },
    data: () => ({
        items: [
            {
                rank: "1",
                name: "홍*동",
                user: "OOOO",
            },
            {
                rank: "1",
                name: "이*신",
                user: "OOOO",
            },
            {
                rank: "1",
                name: "안*근",
                user: "OOOO",
            },
            {
                rank: "2",
                name: "유*순",
                user: "OOOO",
            },
            {
                rank: "2",
                name: "윤*길",
                user: "OOOO",
            },
            {
                rank: "3",
                name: "이*사",
                user: "OOOO",
            },
            {
                rank: "3",
                name: "김*옥",
                user: "OOOO",
            },
            {
                rank: "3",
                name: "김*봉",
                user: "OOOO",
            },
        ],
    }),

    async mounted() {
        await this.init();
    },

    methods: {
        async init() {
            this.$nextTick(() => {
                new Swiper(".score-board .swiper-container", {
                    slidesPerView: 2,
                    spaceBetween: 10,
                    centeredSlides: true,
                    speed: 2000,
                    autoplay: {
                        delay: 0,
                        disableOnInteraction: false,
                    },
                    loop: true,
                    loopAdditionalSlides: 1,
                    breakpoints: {
                        1024: {
                            slidesPerView: 5,
                            spaceBetween: 10,
                        },
                    },
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.score-board {
    font-family: "UhBeeSe_hyun";
    font-size: 18px;
    line-height: 1.35;
    text-align: center;
    .swiper-container {
        color: #fff;
        overflow: visible;
    }
}
@media (min-width: 768px) {
    .score-board {
        font-size: 24px;
        line-height: 1;
    }
}
</style>